module.exports = __webpack_public_path__ + "static/media/cf.2d551ba5.svg";